import React, {  Component } from 'react';
import {addressValidationErrorCode} from "../../redux/util/addressValidationErrorCodes";
import AddressVerificationForm from '../common/addressVerificationForm';

export default class addShippingAddressOverlayDialogVerify extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			enteredAddressIsCorrectOrNot: true,
			errorState :[]
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
    }
	onChangeWhichAddress(event) {
        this.setState({
            enteredAddressIsCorrectOrNot: (event.target.value==='asEntered')?true:false
        })
    }
    componentDidMount() {
		// window.scrollTo(0, 0);
		let entries = Object.entries(addressValidationErrorCode); 
		let resultsErrorCode = this.props.suggestedAddress && this.props.suggestedAddress.responseObject && this.props.suggestedAddress.responseObject.results && this.props.suggestedAddress.responseObject.results.split(",");
		let valueErrorCodeArray =[];
		resultsErrorCode && entries.map( ([key, val]) => {
			if(key == resultsErrorCode[0]){
					valueErrorCodeArray.push(val)
				}
			})
        this.setState({
            showDialog: this.props.showDialog,
			enteredAddressIsCorrectOrNot: this.props.suggestedAddress && this.props.suggestedAddress.status && this.props.suggestedAddress.responseObject && !this.props.suggestedAddress.responseObject.grouponecallerror?false:true,
			errorState : valueErrorCodeArray,
        });
    }
    render() {
		const existingAddress = this.props.existingAddress,
			suggestedAddress = this.props.suggestedAddress;
        const { enteredAddressIsCorrectOrNot } = this.state;
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="addShippingAddressOverlayDialogVerify">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Verify Shipping Address</h2>
					<AddressVerificationForm onAddressSelection={this.onChangeWhichAddress.bind(this)} isEnteredAddressCorrect={enteredAddressIsCorrectOrNot} enteredAddress={existingAddress} suggestedAddress={suggestedAddress} onEditAddress={this.props.handleEditAddress} onUseSelectedAddress={this.props.handleUseSelectedAddress.bind(this, this.state.enteredAddressIsCorrectOrNot)} errors={this.state.errorState} />
                 </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/App/components/dialogs/addShippingAddressOverlayDialogVerify.js